// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
  min-width: 600px;
}

@media print {
  .table {
    font-size: 11px;
  }

  .table td, .table th {
    padding: 2px !important;
  }

  .card {
      box-shadow: none;
      margin-bottom: 0px;
  }
}
.rf {
  padding-left: 2px;
  padding-right: 2px;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
